interface Props {
    className?: string
    FillColor?: string
}

export default function News({className, FillColor}:Props) {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" className={className}>
            <path
                d="M13.8 19.5C14.4627 19.5 15 18.9627 15 18.3C15 18.1343 14.8657 18 14.7 18H10.2C9.53726 18 9 18.5373 9 19.2C9 19.3657 9.13431 19.5 9.3 19.5H13.8Z"
                fill={FillColor}/>
            <path
                d="M5.25 5.25C5.25 3.17893 6.92893 1.5 9 1.5H15C17.0711 1.5 18.75 3.17893 18.75 5.25V18.75C18.75 20.8211 17.0711 22.5 15 22.5H9C6.92893 22.5 5.25 20.8211 5.25 18.75V5.25ZM9 3C7.75736 3 6.75 4.00736 6.75 5.25V18.75C6.75 19.9926 7.75736 21 9 21H15C16.2426 21 17.25 19.9926 17.25 18.75V5.25C17.25 4.00736 16.2426 3 15 3H14.9128C14.7348 3.43977 14.3036 3.75 13.8 3.75H10.2C9.69639 3.75 9.26524 3.43977 9.08723 3H9Z"
                fill={FillColor}/>
        </svg>
    )
}
